import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { OrgsService } from './orgs.service';
import { Observable } from 'rxjs';

@Component({
    standalone: true,
    imports: [
        CommonModule,
        RouterModule,
    ],
    selector: 'app-org-renderer',
    template: `
    <div class="tw-flex tw-items-center tw-h-full">
      <a
        *ngIf="orgName$ | async as orgName; else loading"
        [routerLink]="['/admin/identity/orgs', orgId]"
        class="tw-text-blue-600 hover:tw-text-blue-800 dark:tw-text-blue-400 dark:hover:tw-text-blue-300"
        (click)="$event.stopPropagation()"
      >
        {{ orgName }} ({{ orgId }})
      </a>
      <ng-template #loading>
        <span class="tw-text-gray-500">{{ orgId }}</span>
      </ng-template>
    </div>
  `
})
export class OrgRendererComponent implements ICellRendererAngularComp {
  public orgId: string;
  public orgName$: Observable<string>;

  constructor(private orgsService: OrgsService) {}

  agInit(params: ICellRendererParams): void {
    this.orgId = params.value;
    if (this.orgId) {
      this.orgName$ = this.orgsService.getOrgNameById(this.orgId);
    }
  }

  refresh(params: ICellRendererParams): boolean {
    this.orgId = params.value;
    if (this.orgId) {
      this.orgName$ = this.orgsService.getOrgNameById(this.orgId);
    }
    return true;
  }
}
